'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.accordion-icon {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  min-height: 20px;\n  border: 0;\n  position: relative;\n}\n\n.accordion-icon span {\n  position: absolute;\n  transition: 300ms;\n  background: #1D66DD;\n  border-radius: 2px;\n}\n\n/* Create the \"+\" shape by positioning the spans absolutely */\n.accordion-icon span:first-child {\n  top: 10%;\n  bottom: 10%;\n  width: 10%;\n  left: 45%;\n}\n\n.accordion-icon span:last-child {\n  left: 10%;\n  right: 10%;\n  height: 12%;\n  top: 45%;\n}\n\n.accordion-icon.open span {\n  transform: rotate(90deg);\n  background: #EF6767;\n}\n\n.accordion-icon.open span:last-child {\n  left: 50%;\n  right: 50%;\n}");
//# sourceMappingURL=AccordionIcon.scss.js.map
